import {COUNTRY_CODES} from './countryConstants'

// Countries that should use the new theme feature entrypoints.
export const NEW_THEME_FEATURE_COUNTRIES = [COUNTRY_CODES.US, COUNTRY_CODES.DO, COUNTRY_CODES.PE, COUNTRY_CODES.TR, COUNTRY_CODES.CL, COUNTRY_CODES.EC,COUNTRY_CODES.MX]
